const svg4Everybody = require('svg4everybody');

class App {
  init() {
    this.registerPolyfills();
    this.launchPew();
    this.launchSvg4Everybody();
  }

  launchPew() {
    if (window.pew) { window.pew.enhanceRegistry(); }
  }

  launchSvg4Everybody() {
    svg4Everybody();
  }

  registerPolyfills() {
    if (typeof Object.assign != 'function') {
      Object.assign = function (target) {
        'use strict';
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }
        return target;
      };
    }
  }
}

let app = new App();
app.init();

$(document).ready(function(){
  if(window.innerWidth>=768) {
    let $wrapper = $(".home-video-wrapper");
    if ($wrapper.length && $wrapper.data('vide')) {
      const videoData = $wrapper.data('vide');
      if (videoData && typeof videoData.getVideoObject === 'function') {
        const videoObject = videoData.getVideoObject();
        if (videoObject && typeof videoObject.play === 'function') {
          videoObject.play();
        }
      }
    }
  }
});
